import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import UsersClientActions from "../modules/UsersClientActions/UsersClientActionsPage";

export function UsersClientActionsPage() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "users-client-actions-page-title",
    defaultMessage: "Users client actions"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <UsersClientActions/>;
}
